// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"previewBulkCandidateUploadModal_tableStyle__3PG_s"};